import { ContextItemType } from 'src/@types/ai';
import { IDriveContent } from 'src/@types/drive';
import { type PopoverProps } from 'src/components/PopoverTrigger';
import { DriveExplorer } from 'src/components/explorer/drive/DriveExplorer';
import { AIInputStateControl } from '../useAIInputState';

const validMimeTypes = ['image', 'text', 'application/pdf'];

type Props = PopoverProps<{
  control: AIInputStateControl;
}>;

export const AIContextDriveMenu = ({ control, handleClose, target }: Props) => {
  const { toggleContextFiles, hasContextFile } = control((s) => ({
    toggleContextFiles: s.toggleContextFiles,
    hasContextFile: s.hasContextFile,
  }));

  return (
    <DriveExplorer
      open
      anchorEl={target}
      onClose={handleClose}
      selectFile={(file: IDriveContent) =>
        toggleContextFiles(ContextItemType.DRIVE, file)
      }
      isSelected={(file: IDriveContent) =>
        hasContextFile(ContextItemType.DRIVE, file)
      }
      validMimeTypes={validMimeTypes}
    />
  );
};
